import React, {ReactNode, useMemo, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WizTable from '../../../components/table/TableFactory'
import WizPagination from '../../../components/pagination/WizPagination'
import useQueryAbnormalList from '../../../hooks/api/abnormal/useQueryAbnormalList'
import {ComponentItem, CreateComponent} from '../../../components/useComponent'
import Text from '../../../components/text/Text'
import {useTime} from '../../../utils/time'
import useNavigation from '../../../hooks/useNavigation'

interface IProps {
    className?: string
}

const AbnormalContainer: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const {convertUtc0ToUtc9} = useTime()
    const {goAbnormalDatail} = useNavigation()

    const {data, refetch} = useQueryAbnormalList(currentPage)
    const headerTitles: string[] = ['User ID', 'Amount', 'status', 'Add At']
    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))

    const rows = useMemo(() => {
        if (data === undefined || data?.data?.length === 0) {
            return []
        }

        return data?.data?.map<ReactNode[]>(el => [
            <div
                className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}
                onClick={() => goAbnormalDatail(el._id)}>
                {CreateComponent(Text, {children: el.key_id})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.amounts.reduce((acc, cv) => acc + cv.amount, 0)})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.status})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: convertUtc0ToUtc9(el.added_at)})}
            </div>,
        ])
    }, [data, convertUtc0ToUtc9])

    return (
        <>
            <PageLayout className={''} title="Unknown Transfer">
                <WizTable gridCols="4" className="w-full" headers={headers} items={rows} />
                <WizPagination
                    totalPage={data?.pageInfo?.total_count}
                    currentPage={currentPage}
                    onPageChange={item => setCurrentPage(item)}
                />
            </PageLayout>
        </>
    )
}

export default AbnormalContainer
